/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class ScheduledMessagesAPI extends ApiClient {
  constructor() {
    super('loco/scheduled_messages', { accountScoped: true });
  }

  forConversation(conversationId) {
    return axios.get(this.url, { params: { conversation_id: conversationId } });
  }

  // payload: { content, private, next_run_at, time_zone, recurrence, cancel_on_reply, skip_if_resolved, files }
  createInConversation(conversationId, payload) {
    const url = this.url.replace(
      /scheduled_messages$/,
      `conversations/${conversationId}/scheduled_messages`
    );
    const { files = [], recurrence, ...fields } = payload;
    if (!files.length) return axios.post(url, { ...fields, recurrence });

    const form = new FormData();
    Object.entries(fields).forEach(([key, value]) => {
      if (value !== undefined && value !== null) form.append(key, value);
    });
    form.append('recurrence', recurrence ? JSON.stringify(recurrence) : '');
    files.forEach(file => form.append('files[]', file));
    return axios.post(url, form);
  }

  sendNow(id) {
    return axios.post(`${this.url}/${id}/send_now`);
  }
}

export default new ScheduledMessagesAPI();
